/**
 * Quick-view variant image filter using Rubik craftshift.variantImages metafield.
 * Rubik app JS does not run in quick-view; this mirrors its hide logic.
 */
(function () {
  'use strict';

  function getQuickViewRoot() {
    return document.getElementById('Product-Drawer-Content');
  }

  function filenameFromSrc(src) {
    if (!src) return '';
    var imageName = src.split('/').pop();
    var name = imageName.split('.').slice(0, -1).join('.');
    return name.replace(/(_\d+x(\d+)?|_crop_center|_small|@2x)/g, '');
  }

  function mediaIdFromSlide(slide) {
    if (slide.dataset.dbMediaId) return String(slide.dataset.dbMediaId);
    var raw = slide.dataset.mediaId || '';
    return raw.split('-').pop();
  }

  function variantKey(imagesPerVariantId, variantId) {
    if (imagesPerVariantId[variantId]) return variantId;
    var str = String(variantId);
    if (imagesPerVariantId[str]) return str;
    return null;
  }

  function getMediaIdsToHide(variantImages, variantId) {
    var configuredMediaIds = (variantImages.configuredMediaIds || []).map(String);
    var mediaIdsPerVariantId = variantImages.mediaIdsPerVariantId || {};
    var key = variantKey(mediaIdsPerVariantId, variantId);
    var mediaIdsToShow = key ? (mediaIdsPerVariantId[key] || []).map(String) : [];

    if (!configuredMediaIds.length || !Object.keys(mediaIdsPerVariantId).length) {
      return [];
    }

    if (mediaIdsToShow.length > 0) {
      return configuredMediaIds.filter(function (id) {
        return mediaIdsToShow.indexOf(id) === -1;
      });
    }

    return configuredMediaIds.slice();
  }

  function getFilenamesToHide(variantImages, variantId) {
    var imageUrls = variantImages.imageUrls || [];
    var imagesPerVariantId = variantImages.imagesPerVariantId || {};
    var key = variantKey(imagesPerVariantId, variantId);
    var visible = key ? (imagesPerVariantId[key] || []) : imageUrls;

    return imageUrls.filter(function (url) {
      return visible.indexOf(url) === -1;
    });
  }

  function applyRubikFilter(variantId, variantImages, container) {
    if (!variantImages || !container) return;

    var mediaIdsToHide = getMediaIdsToHide(variantImages, variantId);
    var hideMediaSet = {};
    mediaIdsToHide.forEach(function (id) {
      hideMediaSet[id] = true;
    });

    var filenamesToHide = getFilenamesToHide(variantImages, variantId);
    var hideFilenameSet = {};
    filenamesToHide.forEach(function (name) {
      hideFilenameSet[name] = true;
    });

    var slides = container.querySelectorAll('.product-quick-images__slide');
    var firstVisible = null;

    slides.forEach(function (slide) {
      var hide = !!hideMediaSet[mediaIdFromSlide(slide)];

      if (!hide) {
        var img = slide.querySelector('img');
        if (img) {
          var fn = filenameFromSrc(img.currentSrc || img.src);
          if (hideFilenameSet[fn]) hide = true;
        }
      }

      slide.classList.toggle('db-rubik-hidden', hide);
      slide.style.display = hide ? 'none' : '';

      if (!hide && !firstVisible) {
        firstVisible = slide;
      }
    });

    slides.forEach(function (slide) {
      slide.classList.remove('is-active');
    });

    if (firstVisible) {
      firstVisible.classList.add('is-active');
      firstVisible.scrollIntoView({ block: 'nearest', inline: 'start', behavior: 'instant' });
      container.scrollTo({ left: 0, top: 0, behavior: 'instant' });
    }
  }

  function patchVariantSelects(root) {
    root.querySelectorAll('variant-selects, variant-radios').forEach(function (vs) {
      vs.updateMedia = function () {};
    });
  }

  function readVariantImages(root) {
    var node = root.querySelector('[data-db-rubik-variant-images]');
    if (!node) return null;
    try {
      return JSON.parse(node.textContent);
    } catch (e) {
      console.warn('[db-quick-view-rubik] Failed to parse Rubik metafield JSON', e);
      return null;
    }
  }

  function resolveVariantId(root) {
    var variantSelect = root.querySelector('variant-selects, variant-radios');
    if (variantSelect && variantSelect.currentVariant && variantSelect.currentVariant.id) {
      return variantSelect.currentVariant.id;
    }

    var span = root.querySelector('[id^="SelectedVariant-"]');
    if (span && span.dataset.variantId) {
      return parseInt(span.dataset.variantId, 10);
    }

    return null;
  }

  function initQuickView() {
    var root = getQuickViewRoot();
    if (!root) return;

    var container = root.querySelector('.product-quick-images');
    var variantImages = readVariantImages(root);
    if (!container || !variantImages) return;

    patchVariantSelects(root);

    var variantId = resolveVariantId(root);
    if (variantId) {
      applyRubikFilter(variantId, variantImages, container);
    }

    var scheduleFilter = function () {
      window.setTimeout(function () {
        var images = readVariantImages(root);
        var id = resolveVariantId(root);
        if (id && images) applyRubikFilter(id, images, container);
      }, 450);
    };

    var drawer = document.getElementById('Product-Drawer');
    if (drawer && drawer.dataset.dbRubikBound !== 'true') {
      drawer.dataset.dbRubikBound = 'true';
      drawer.addEventListener('change', function (event) {
        if (event.target.closest('variant-selects, variant-radios')) {
          scheduleFilter();
        }
      });
    }
  }

  document.addEventListener('product:variant-change', function () {
    if (!getQuickViewRoot() || !getQuickViewRoot().querySelector('[data-db-rubik-variant-images]')) return;
    window.setTimeout(initQuickView, 450);
  });

  document.addEventListener('quick-view:open', function () {
    requestAnimationFrame(function () {
      requestAnimationFrame(initQuickView);
    });
  });

  window.DbQuickViewRubik = { init: initQuickView };
})();
